import React from 'react';
import { css } from '@linaria/core';
import forwardRefAs from 'forward-ref-as';
import { brand, findColorFromCSSVariable, theme } from '@terveystalo/design-system-theme';
import { Icon } from '../Icon';
import { classnames } from '../../utils';
import { focusBoxShadow } from '../../css-utils/focus-visible';
import { sharedButtonStyles } from '../Button';
import { useColorFilter } from '../../css-utils/use-color-filter';
export const defaultPillButtonStyles = css `
  padding: ${theme.spacing['0_5']};

  font-family: ${brand.button.font.text.family};
  font-weight: ${brand.button.font.text.weight};
  letter-spacing: ${brand.button.font.text.letterSpacing};
  font-size: ${brand.button.font.text.size};
  line-height: ${brand.button.font.text.lineHeight};

  color: ${brand.button.color.pill.default.content};
  background-color: ${brand.button.color.pill.default.background.onLight};
  border: ${theme.border.width.xxs} solid ${brand.button.color.pill.default.border};

  &:disabled {
    border-color: ${brand.button.color.pill.disabled.border};
    background-color: ${brand.button.color.pill.disabled.background};
    color: ${brand.button.color.pill.disabled.content};
  }

  &::before {
    background-color: ${brand.button.color.pill.hover.background};
  }

  /* On-press (hover, active) styles */
  &:not(:disabled) {
    &:hover,
    &:active {
      border-color: ${brand.button.color.pill.hover.border};
      color: ${brand.button.color.pill.hover.content};

      > img {
        filter: var(--icon-filter);
      }
    }
  }
`;
const determineIconColor = (state) => {
    return findColorFromCSSVariable(brand.button.color.pill[state].icon);
};
/**
 * Button component which extends the native button element. The native element can be changed with
 * the `as` prop which also provides the types for the specific element attributes/properties.
 */
export const PillButton = forwardRefAs(({ as: Component = 'button', grayBackground, iconLeft, iconRight, className, children, style, ...rest }, ref) => {
    const computedIconColor = determineIconColor(rest.disabled ? 'disabled' : 'default');
    const { component, filter } = useColorFilter({
        color: findColorFromCSSVariable(brand.button.color.pill.hover.icon),
        id: ['pill-button'],
    });
    return (React.createElement(React.Fragment, null,
        component,
        React.createElement(Component, { className: classnames(sharedButtonStyles, defaultPillButtonStyles, focusBoxShadow, grayBackground &&
                css `
                background-color: ${brand.button.color.pill.default.background.onDark};

                &:disabled {
                  background-color: ${brand.button.color.pill.default.background.onDark};
                }
              `, className), ref: ref, style: {
                '--icon-filter': filter,
                ...style,
            }, ...rest },
            iconLeft && React.createElement(Icon, { name: iconLeft, color: computedIconColor }),
            React.createElement("span", { className: css `
              padding: 0 ${theme.spacing['0_5']};
            ` }, children),
            iconRight && React.createElement(Icon, { name: iconRight, color: computedIconColor }))));
});


import "../../../css/atoms/PillButton/PillButton.css";
